import React, { useState, useEffect } from 'react';
import { getUserState, httpPost } from '../utils';

import Success from '../Success/Success';

const OktaSuccess = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(true);
    useEffect(() => {
        if (window.location.search) {
            const search = window.location.search.substring(1);
            const data = JSON.parse(
                '{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
            );

            getUserState().then(() => {
                httpPost('/Settings/OktaAccessTokenResponse', data)
                    .then((res) => {
                        console.log(res.data);
                        if (!res.data || !res.data.result) setIsSuccess(false);
                    })
                    .catch((error) => {
                        setIsSuccess(false);
                        console.log(error);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            });
        }
    }, []);

    return <Success isLoading={isLoading} isSuccess={isSuccess} />;
};

export default OktaSuccess;
